/* Utils */
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

/* Store */
import useModalStore from 'Stores/Modals';
import useFurnituresStore from 'Stores/Furnitures';
import useFurnituresCategoriesStore from 'Stores/FurnituresCategories';

/* Components */
import Modal from 'Components/Modal';
import FormInput from 'Components/FormInput';
import FormSelect from 'Components/FormSelect';

/* Styles */
import './style.scss';

const CreateFurniture = ({ params: { categoryid } }) => {
	// Store
	const hideModal = useModalStore(store => store.hideModal);
	const fetchCategories = useFurnituresCategoriesStore(store => store.fetchCategories);
	const categories = useFurnituresCategoriesStore(store => store.categories);
	const createFurniture = useFurnituresStore(store => store.createFurniture);
	const history = useHistory();

	// State
	const [hasUnit, setHasUnit] = useState(false);
	const [form, setForm] = useState({
		name: '',
		category: '',
		stock_value: '',
		stock_min: '',
		stock_unit: ''
	});

	const getOptions = () => categories && categories.map(category => ({ label: category.name, value: category.id }));
	const handleHideModal = (category) => {
		history.push(`/inventory/furnitures/${category || categoryid}`);
		hideModal();
	};
	const handleSubmit = async () => {
		await createFurniture(form);
		handleHideModal(form.category);
	};

	useEffect(() => {
		if (!categories) {
			fetchCategories();
		}
	}, []);

	const navigation = { icon: 'utilitary_close', action: () => handleHideModal() };
	const button = { label: 'Sauvegarder', action: () => handleSubmit() };

	return (
		<Modal title="Créer une fourniture" navigation={navigation} button={button}>
			<div className="default-modal wrapper">
				<div className="default-modal-content">
					<h2>Création de la fourniture</h2>
					<p>Séparer les variables de la fourniture par des &quot;-&quot;</p>
					<div className="inputs">
						<FormInput
							name="name"
							label="Nom de la fourniture"
							placeholder="Ex: Anneau - or - 6mm"
							value={form.name}
							setValue={(value) => setForm({ ...form, name: value })}
						/>
						<FormSelect
							name="category"
							label="Catégorie de la fourniture"
							value={form.category}
							defaultSelected={categoryid}
							options={getOptions() || []}
							setValue={(value) => setForm({ ...form, category: value })}
						/>
						<FormInput
							name="stock_value"
							type="number"
							label="Combien de fournitures en stock ?"
							placeholder="Ex: 1200"
							value={form.stock_value}
							setValue={(value) => setForm({ ...form, stock_value: value === '' ? value : parseInt(value, 10) })}
						/>
						<FormInput
							name="stock_min"
							type="number"
							label="Stock minimum avant "
							placeholder="Ex: 200"
							value={form.stock_min}
							setValue={(value) => setForm({ ...form, stock_min: value === '' ? value : parseInt(value, 10) })}
						/>

						<p className="unit-question">
							Définir une unité pour le stock ?
							<span onClick={() => setHasUnit(!hasUnit)} tabIndex={0} role="button">
								{hasUnit ? <b>Oui</b> : 'Oui'} / {!hasUnit ? <b className="red">Non</b> : 'Non'}
							</span>
						</p>
						{ hasUnit && (
							<FormInput
								name="stock_min"
								label="Unité en stock"
								placeholder="Ex: mm, cm, m"
								value={form.stock_unit}
								setValue={(value) => setForm({ ...form, stock_unit: value })}
							/>
						)}
					</div>
				</div>
			</div>
		</Modal>
	);
};


CreateFurniture.propTypes = {
	params: PropTypes.shape({
		categoryid: PropTypes.string.isRequired
	}).isRequired
};

export default CreateFurniture;
